module.exports = __webpack_public_path__ + "media/images/mail_template/fb-4ec6cac8f9b851b8f6ed409f81b4953e.png";